import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["number"],
    _excluded2 = ["number", "width", "height", "fill"];
import React from 'react';

var Number = function Number(_ref) {
  var number = _ref.number,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("text", _extends({
    textAnchor: "middle",
    fontFamily: "Barlow, Argos, sans-serif",
    fontSize: "10"
  }, props), /*#__PURE__*/React.createElement("tspan", {
    x: "12",
    y: "14"
  }, number));
};

Number.displayName = 'Number';

var Circle = function Circle() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M11.9 12c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6-1.2 2.6-2.6 2.6zm0-1.5c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1-1.1.5-1.1 1.1.5 1.1 1.1 1.1z"
  });
};

Circle.displayName = 'Circle';

var LocationIcon = function LocationIcon(_ref2) {
  var number = _ref2.number,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '1em' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '1em' : _ref2$height,
      _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? '#333' : _ref2$fill,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), number === undefined ? /*#__PURE__*/React.createElement(Circle, null) : /*#__PURE__*/React.createElement(Number, {
    number: number
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.3c-.3.3-.8.3-1.1 0-5.1-5.4-7.7-9.5-7.7-12.5 0-4.6 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2c.1 3-2.4 7.1-7.6 12.5zM5.2 9.8c0 2.4 2.2 6.1 6.8 10.9 4.5-4.8 6.8-8.5 6.8-10.9C18.8 6 15.7 3 12 3S5.2 6 5.2 9.8z"
  }));
};

LocationIcon.displayName = 'LocationIcon';
export default LocationIcon;